class CartAvailabilityProvider {
    constructor(private readonly canUseCart: boolean) {}

    isCartAvailable(): boolean {
        return this.canUseCart;
    }
}

export default CartAvailabilityProvider;
